import { useEffect, useMemo, useState } from "react";
import BasicInfoFields from "./BasicInfoFields";
import { objectToOptions, hasShallowChanges, isAddressSame } from "./utils";
import regionPh from "../../../../../components/regionsPh.json";
import StepsIndicator from "../../../../../components/StepsIndicator";
import InputFactory from "../../../../../components/InputFactory";
import AddressForm from "./AddressForm";
import CredentialForm from "./CredentialsForm";
import { Progress } from "../../../../../nq-component";
import changes from "../../../../../changes";

function ClientsForm({
  onSubmit,
  onBack,
  object,
  discardModal,
  // businessType,
  isAdmin,
  progress,
  hasActualChanges,
  ...props
}) {
  const [formData, setFormData] = useState({});
  const [hasChanges, setHasChanges] = useState(false);
  const [provincesOptions, setProvinces] = useState([]);
  const [citiesOptions, setCities] = useState([]);
  const [barangayOptions, setBarangay] = useState([]);
  const regionsOptions = useMemo(() => objectToOptions(regionPh), []);
  const [currentStep, setCurrentStep] = useState(0);
  const [isSameAddress, setSameAddress] = useState(false);
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    const base = ["Business Details", "Billing and Shipping Address"];
    if (isAdmin && !object?.id) {
      setSteps([...base, "Client Credentials"]);
    } else {
      setSteps(base);
    }
  }, [isAdmin, object]);

  useEffect(() => {
    setFormData((prevState) => ({ ...prevState, ...object }));
  }, [object]);

  useEffect(() => {
    const changess = changes(formData, object);
    const hasChanges = Object.keys(changess).length > 0;
    setHasChanges(hasChanges);
  }, [object, formData]);

  useEffect(() => {
    if (!object?.id) return;
    const sameAddress = isAddressSame(object);
    setSameAddress(sameAddress);
  }, [object?.id]);

  const handleChange = (value, field) => {
    if (field === "companyName" && value === !null) {
      setFormData((prev) => ({ ...prev, name: value }));
    }
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let updatedObject = {
      ...formData,
      shippingRegion: formData?.billingRegion,
      shippingProvince: formData?.billingProvince,
      shippingCity: formData?.billingCity,
      shippingBarangay: formData?.billingBarangay,
    };

    // if (currentStep === 0 || currentStep === 1) {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      onSubmit(isSameAddress ? updatedObject : formData);
    }
  };

  const _onCancel = () => {
    const modified = hasShallowChanges(formData, object);
    if (modified) {
      return discardModal();
    }

    onBack();
  };

  const toggleBoolean = () => {
    setSameAddress((prevState) => !prevState);
  };

  useEffect(() => {}, [hasActualChanges, currentStep, steps]);
  return (
    <div className="d-flex flex-column">
      {!formData?.id && (
        <StepsIndicator currentStep={currentStep} steps={steps} />
      )}
      <div className="m-0 bg-white">
        <form onSubmit={handleSubmit}>
          {currentStep === 0 && (
            <BasicInfoFields
              formData={formData}
              onChange={handleChange}
              className="bg-white"
              {...props}
            />
          )}
          {currentStep === 1 && (
            <>
              <AddressForm
                title={"Billing Address"}
                description={"Billing address for the client"}
                icon={"bi bi-geo-alt"}
                formData={formData}
                onChange={handleChange}
                type={"billing"}
                {...props}
              />

              <InputFactory
                type="Boolean"
                label="Same as Billing Address?"
                field={"sameAddress"}
                value={isSameAddress}
                onChange={toggleBoolean}
                {...props}
              />

              {!isSameAddress && (
                <AddressForm
                  title={"Shipping Address"}
                  description={"Shipping address for the client"}
                  icon={"bi bi-geo-alt"}
                  formData={formData}
                  onChange={handleChange}
                  type={"shipping"}
                  {...props}
                />
              )}
            </>
          )}
          {currentStep === 2 && isAdmin && !formData.id ? (
            <>
              <CredentialForm onChange={handleChange} {...props} />
            </>
          ) : (
            ""
          )}
          <div className="d-flex gap-2 mt-4">
            {currentStep === 0 ? (
              <button
                type="button"
                className="btn btn-light card w-100 fw-medium"
                onClick={() => _onCancel()}
              >
                Cancel
              </button>
            ) : (
              <button
                type="button"
                className="btn card w-100 btn-light fw-medium"
                onClick={() => {
                  setCurrentStep(currentStep - 1);
                }}
              >
                Back
              </button>
            )}

            {currentStep < steps.length - 1 ? (
              <button
                type="submit"
                className="w-100 rounded-2 text-white btn btn-primary fw-medium"
                disabled={progress}
              >
                Next
              </button>
            ) : (
              <button
                type="submit"
                className="w-100 rounded-2 text-white btn btn-primary fw-medium"
                disabled={
                  progress || (currentStep === steps.length && !hasChanges)
                }
              >
                {progress ? (
                  <span className="d-flex gap-2">
                    <Progress /> {!formData?.id ? "Submitting" : "Updating"}
                  </span>
                ) : !formData?.id ? (
                  "Submit"
                ) : (
                  "Update"
                )}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default ClientsForm;
